import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption, RoomExtraOptionPerTimeRange } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

const optionsForPerTimeRange = (options: RoomExtraOptionPerTimeRange[]) =>
  options.map((option, index) => ({
    label: `${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(0, 5)}`,
    value: index,
  }));

type SelectOption = { label: string; value: number };

export const PerTimeRange = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const opts = optionsForPerTimeRange(options as RoomExtraOptionPerTimeRange[]);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
